import { PropsWithChildren } from 'react';

import { AspectRatio } from '@ravago/shared/radiance/components/aspect-ratio/components/AspectRatio/AspectRatio';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';

export const RfqImage = ({ children }: PropsWithChildren) => (
   <Box spacing={{ top: 'xl' }} direction="column" items="center">
      <Box maxWidth="500px">
         <AspectRatio aspectRatio="16:9" width="100%">
            {children}
         </AspectRatio>
      </Box>
   </Box>
);
